import { Component, OnInit, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { PaymentRefundReason } from './../../../../models/payment-refund-reason.enum';
import { TetherDialog } from "../../../common-module/modules/tether-dialog/tether-dialog";


@Component({
  selector: 'app-blocked-modal',
  templateUrl: './blocked-modal.component.html',
  styleUrls: ['./blocked-modal.component.scss']
})
export class BlockedModalComponent implements OnInit {
  @HostBinding('class.oc-transaction-refund-box') true;
  selectedRoleColor?:string;
  note?:string;

  public roleColorOptions = [
    {text: '', value: ''},
		{text: 'Organizatör', value: '#800080'},
		{text: 'Sponsor', value: '#00CC00'},
		{text: 'Görevli / Misafir', value: '#66FFFF'},
		{text: 'Kombine', value: '#808080'},
		{text: 'Diğer', value: '#FF00FF'},


	]
  
  constructor(
    public tetherDialog: TetherDialog
  ) { }

  ngOnInit() {

  }

  public onInputChange(e,type){
    console.log('e',e)
     type ==='category' ? this.selectedRoleColor = e: this.note = e
  
  }

  public submitClickHandler(e){
    this.tetherDialog.close({
      categoryRoleColor: this.selectedRoleColor,
      note:this.note
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/boxoffice-module/common/blocked-modal/blocked-modal.component.ts